/* Animation curves */
export const easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) {return (c / 2) * t * t + b;}
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

export const easeInQuart = function (t, b, c, d) {
    t /= d;
    return c * t * t * t * t + b;
};

export const easeOutQuart = function (t, b, c, d) {
    t /= d;
    t--;
    return -c * (t * t * t * t - 1) + b;
};

export const easeInOutQuart = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) {return (c / 2) * t * t * t * t + b;}
    t -= 2;
    return (-c / 2) * (t * t * t * t - 2) + b;
};

export const easeOutElastic = function (t, b, c, d) {
    let s = 1.70158;
    let p = d * 0.7;
    let a = c;
    if (t == 0) {return b;}
    if ((t /= d) == 1) {return b + c;}
    if (!p) {p = d * 0.3;}
    if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
    } else {
        s = (p / (2 * Math.PI)) * Math.asin(c / a);
    }
    return (
        a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
        c +
        b
    );
};
